import { render, staticRenderFns } from "./HKLLoadMore.vue?vue&type=template&id=3ed16d31&scoped=true&"
import script from "./HKLLoadMore.vue?vue&type=script&lang=js&"
export * from "./HKLLoadMore.vue?vue&type=script&lang=js&"
import style0 from "./HKLLoadMore.vue?vue&type=style&index=0&id=3ed16d31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed16d31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed16d31')) {
      api.createRecord('3ed16d31', component.options)
    } else {
      api.reload('3ed16d31', component.options)
    }
    module.hot.accept("./HKLLoadMore.vue?vue&type=template&id=3ed16d31&scoped=true&", function () {
      api.rerender('3ed16d31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Loading/HKLLoadMore.vue"
export default component.exports